<template>
  <div class="d-flex flex-row flex-md-nowrap flex-wrap-reverse align-start">
    <slot name="button" />
    <price-table
      :big-sum="bigSum"
      :gross-portal="grossPortal"
      :cart-info="cartInfo"
      :is-supplier-cart="isSupplierCart"
      class="flex-shrink-0"
    />
  </div>
  <slot name="terms" />
</template>

<script setup lang="ts">
import PriceTable from '@/modules/cart/components/PriceTable.vue'
import { CartInfo } from '@/types/index'
import { PropType } from 'vue'

defineProps({
  cartInfo: {
    type: Object as PropType<CartInfo>,
    required: true
  },
  grossPortal: {
    type: Boolean,
    required: true
  },
  isSupplierCart: {
    type: Boolean,
    required: true
  },
  bigSum: {
    type: Boolean,
    default: false
  }
})
</script>
